export const environment = {
  production: true,
  api: 'https://api.eclesial.domusdata.com.br',
};
